<template>
  <div v-if="page && page.totalElements" class="d-flex align-items-center">
    <b-button
      variant="primary"
      v-if="isMdUp"
      :disabled="page.number < 1"
      @click.prevent="$emit('selectPage', 0)">
      {{ $t('pager.first') }}
    </b-button>
    <b-button
      variant="primary"
      v-if="isMdUp"
      class="mr-2"
      :disabled="page.number < 1"
      @click.prevent="$emit('selectPage', page.number - 1)">
      {{ $t('pager.previous') }}
    </b-button>
    {{ $t('pager.page') }} <options-form-field
      class="d-inline-block mb-0 mx-1"
      dropdown
      :value="page.number + 1"
      :options="pageOptions"
      @input="$emit('selectPage', $event - 1)"
    /> {{ $t('pager.outOf', { totalPages: page.totalPages }) }}
    <b-button
      variant="primary"
      v-if="isMdUp"
      class="ml-2"
      :disabled="page.number >= page.totalPages - 1"
      @click.prevent="$emit('selectPage', page.number + 1)">
      {{ $t('pager.next') }}
    </b-button>
    <b-button
      variant="primary"
      v-if="isMdUp"
      :disabled="page.number >= page.totalPages - 1"
      @click.prevent="$emit('selectPage', page.totalPages - 1)">
      {{ $t('pager.last') }}
    </b-button>

    <!--
    <span class="pl-4">Show up to <options-form-field
      class="d-inline-block"
      dropdown
      :value="page.size"
      :options="pageSizeOptions"
      @input="$emit('selectPageSize', $event)"
    /> results.</span>
    -->
  </div>
</template>
<script>
import range from 'lodash/range';

export default {
  props: {
    page: {
      type: Object,
      default: undefined
    }
  },

  computed: {
    /*
    pageSizeOptions() {
      return [
        { value: 0, text: 'All' },
        { value: 3, text: '3' },
        { value: 5, text: '5' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
      ];
    },
    */

    pageOptions() {
      return range(1, this.page.totalPages + 1);
    },
  },
};
</script>
